module.exports = __webpack_public_path__ + "static/media/global-bible-logo-horiz-bk.cbb1fac2.svg";